import styled from 'styled-components'

const NotificationsStyle = styled.div.attrs()`
    position: absolute;
    top:100%;
    right:0;
    background-color: var(--white);
    width: var(--sp52x);
    padding:var(--sp4x);
    border-radius: 20px;
    opacity: 0;
    z-index: 3;
    pointer-events: none;
    transition: var(--trTime);
    box-shadow: 0px 0px 10px 4px rgba(0, 0, 0, 0.1);

    .not-found {
        width:100% ;
        padding-top:55%;
    }
    &.active {
        opacity: 1;
        pointer-events: all;
    }

    .single-not {
        padding-bottom: var(--sp3x);
        
        &:not(:first-of-type){
            margin-top: var(--sp3x);
        }
        
        &:not(:last-of-type){
            border-bottom:1px solid var(--lightGrey);
        }

        i {
            font-size:var(--sp3x) ;
            margin-left: 0;
        }

        .imageCont {
			width: var(--sp3x);
			height: var(--sp3x);
			margin-right: var(--spSize);
            padding: var(--spSize) 12px;
		}

        .info {
            margin-left: var(--sp2x);

            .text {
                margin:var(--spSize) 0;
                display: -webkit-box;
                -webkit-line-clamp: 3;
                -webkit-box-orient: vertical;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }
    }

    .see-all {
        position: absolute;
        bottom:var(--sp2x);
        right:var(--sp2x);
    }

    @media screen and (max-width: ${(props) => props.theme.mediaQuery.MobileSize}) {
        width: calc(100vw - var(--sp4x));
        padding:var(--sp3x);

        .see-all {
            bottom:var(--spSize);
        }
    }
`

export default NotificationsStyle
